/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/DocumentScannerScreens.yaml
import { CameraScreenConfiguration } from './CameraScreenConfiguration';
import { CroppingScreenConfiguration } from './CroppingScreenConfiguration';
import { ReorderPagesScreenConfiguration } from './ReorderPagesScreenConfiguration';
import { ReviewScreenConfiguration } from './ReviewScreenConfiguration';
/**
Configuration of the document scanner sub-screens.
*/
export class DocumentScannerScreens {
    /** @param source {@displayType `DeepPartial<DocumentScannerScreens>`} */
    constructor(source = {}) {
        /**
          Configuration of the screen for scanning the pages with the camera.
          */
        this.camera = new CameraScreenConfiguration({});
        /**
          Configuration of the screen for reviewing the scanned pages.
          */
        this.review = new ReviewScreenConfiguration({});
        /**
          Configuration of the screen for cropping the scanned pages.
          */
        this.cropping = new CroppingScreenConfiguration({});
        /**
          Configuration of the screen for reordering the scanned pages.
          */
        this.reorderPages = new ReorderPagesScreenConfiguration({});
        if (source.camera !== undefined) {
            this.camera = new CameraScreenConfiguration(source.camera);
        }
        if (source.review !== undefined) {
            this.review = new ReviewScreenConfiguration(source.review);
        }
        if (source.cropping !== undefined) {
            this.cropping = new CroppingScreenConfiguration(source.cropping);
        }
        if (source.reorderPages !== undefined) {
            this.reorderPages = new ReorderPagesScreenConfiguration(source.reorderPages);
        }
    }
}
//# sourceMappingURL=DocumentScannerScreens.js.map